import React from 'react'
import WithdrawalEN from './withdrawal/WithdrawalEN'
import WithdrawalDE from './withdrawal/WithdrawalDE'
import useLanguage from '@hooks/useLanguage.hook'

const Withdrawal = () => {
    const [lng] = useLanguage()

    return <div>{lng.includes('en') ? <WithdrawalEN /> : <WithdrawalDE />}</div>
}

export default Withdrawal
